// extracted by mini-css-extract-plugin
export var createdDate = "_eg-1";
export var divider = "_eg-2";
export var headerDivider = "_eg-3";
export var messagesCard = "_eg-0";
export var messagesContainer = "_eg-6";
export var messagesContainerWrapper = "_eg-4";
export var showLeftPanelButton = "_eg-8";
export var topButtons = "_eg-7";
export var withPadding = "_eg-5";